import { Form, Col, Row } from "antd";
import { useEffect } from "react";
import CustomInput from "./inputWidgets/CustomInput";

const AccountForm = ({ adminInfo, title, icon, type }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (adminInfo) {
      form.setFieldsValue(adminInfo);
    }
  }, [adminInfo]);

  if (type !== "info") return null;

  return (
    <Form
      validateTrigger="onChange"
      form={form}
      onFinish={(values) => console.log("Submitted values", values)}
      scrollToFirstError
      layout="vertical"
      autoComplete="off"
    >
      <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
        <div className="flex items-center bg-gray-200 p-2.5">
          {icon && <span className="mr-2 text-[18px] text-black">{icon}</span>}
          <span className="text-[.935rem] text-black font-['Poppins']">
            {title}
          </span>
        </div>

        <div className="px-2 pt-1 pb-3">
          <Row gutter={[16, 8]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <CustomInput
                label="Username"
                name="UserId"
                disabled
                autoComplete="off"
                // required
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <CustomInput
                label="Email"
                name="Email"
                type="email"
                isEmail
                disabled
                // required
              />
            </Col>
          </Row>
        </div>
      </div>
    </Form>
  );
};

export default AccountForm;
